import { render, staticRenderFns } from "./wenbenti.vue?vue&type=template&id=7135674c&"
import script from "./wenbenti.vue?vue&type=script&lang=ts&"
export * from "./wenbenti.vue?vue&type=script&lang=ts&"
import style0 from "./wenbenti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports